<template>
    <vx-card id="input-form-social-security">
        <div class="vx-row radioButtons" v-if="showSalaryRadio">
            <div id="completeSalary">
                <vs-radio
                    v-model="completeSalarySwitch"
                    vs-value="1"
                    id="completeSalarySwitch"
                    @input="calculateCapitalsNeeded()"
                    style="vertical-align:middle"
                    >
                </vs-radio>
                <label class="mr-1 coverInput-title title clickable-icon" style="vertical-align:middle">Salario completo </label>

                <div class="vx-col tooltip" style="vertical-align:middle">
                    <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                    <span class="tooltiptext salary-tooltip">Calcularemos la cobertura para mantener tus ingresos actuales. 
                        En todo caso, puedes ajustar las cifras a tus preferencias.</span>
                </div>
            </div>
            <div id="partialSalary">
                <vs-radio
                    v-model="completeSalarySwitch"
                    vs-value="0"
                    @input="calculateCapitalsNeeded()"
                    id="otherQuantity"
                    style="vertical-align:middle"
                    >
                </vs-radio>
                <label class="mr-1 coverInput-title title clickable-icon" style="vertical-align:middle">Recomendado </label>
                <div class="vx-col tooltip" style="vertical-align:middle">
                    <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                    <span class="tooltiptext salary-tooltip">Calcularemos la cobertura que necesitas según nuestro criterio. 
                        En todo caso, puedes ajustar las cifras a tus preferencias.</span>
                </div>
            </div>
        </div>


        <div class="vx-row mt-5">
            
            <div class="vx-row w-full tableTitles">
                    <div class="vx-col coverInfo">
                        <div class="vx-row">
                            <span class="title">Prestaciones</span>

                        </div>
                    </div>

                    <div class="vx-col tooltip-need">
                            <label class="mr-1 coverInput-title title clickable-icon" style="vertical-align:middle">Necesidad total mensual</label>
                            <div class="tooltip" style="vertical-align:middle">
                                <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon>
                                <span id="need-tooltip" class="tooltiptext need-tooltip">Importe mensual que necesitas para pagar los gastos.</span>
                            </div>
                        
                        <!-- <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6"></vs-icon> -->
                        <!-- <span class="tooltiptext">Se refiere a la cantidad de € que necesitas al mes, en caso de que ocurra dicho caso</span> -->
                    </div>
                
            </div>

        </div>

        <vx-card
            v-if="temporaryDisability != null"
            actionable
            :style="{backgroundColor: temporaryDisability.bool ? 'rgba(var(--vs-secundary), 0.18)' : 'none'}"
            class="cover-card"
            >
            <div class="vx-row card-display">
                <div class="vx-col card-description">
                    <div class="title-card">
                        <div class="vx-row">
                            <vs-switch 
                                class="switch-capital mr-4" 
                                v-model="temporaryDisability.bool" 
                                @click="changeSwitchCapital(temporaryDisability)"
                                :disabled="temporaryDisability.disabled == true"
                                ></vs-switch>
                            <span> {{temporaryDisability.name}}</span>
                        </div>
                    </div>

                    <div class="info-card">
                        <span class="info">En el caso de una baja laboral percibirías </span>
                        <span class="capital">{{this.numberWithCommas(temporaryDisability.social)}} €/mes</span>
                        <span class="info">. Piensa en tus gastos y si con esa cantidad podrías pagarlos, en caso contrario, pon la cantidad mensual necesaria.</span>
                    </div>
                </div>

                <div class="vx-col input-card" >
                    <md-field>
                        <md-input
                            v-on:keypress="NumbersOnly"
                            name="temporaryDisability"
                            style="text-align: center"
                            required
                            v-validate="'required'"
                            val-icon-danger="warning"
                            class="w-full"
                            v-model="temporaryDisability.needText"
                            :disabled="temporaryDisability.disabled == true"
                            @change="checkValues(temporaryDisability)"
                            @input="includeCommas(temporaryDisability)"
                        ></md-input>
                        <span class="md-suffix"> €</span>
                    </md-field>
                </div>
            </div>
        </vx-card>

        <vx-card
            v-if="totalPermanentDisability != null"
            actionable
            :style="{backgroundColor: totalPermanentDisability.bool ? 'rgba(var(--vs-secundary), 0.18)' : 'none'}"
            class="cover-card"
            >
            <div class="vx-row card-display">
                <div class="vx-col card-description">
                    <div class="title-card">
                        <div class="vx-row">
                            <vs-switch 
                                class="switch-capital mr-4" 
                                v-model="totalPermanentDisability.bool" 
                                @click="changeSwitchCapital(totalPermanentDisability)"
                                :disabled="totalPermanentDisability.disabled == true"
                                ></vs-switch>
                            <span> {{totalPermanentDisability.name}}</span>
                        </div>
                    </div>

                    <div class="info-card" v-if="totalPermanentDisability.disabled == false">
                        <span class="info">Si no pudieses ejercer tu profesión habitual, percibirías </span>
                        <span class="capital">{{this.numberWithCommas(totalPermanentDisability.social)}} €/mes</span>
                        <span class="info">. Esta situación en la mayoría de los casos obligaría a iniciar un nuevo proyecto profesional. Pon la cantidad mensual que necesitarías para 
                            ese periodo de adaptación.</span>
                    </div>
                    <div class="info-card" v-else>
                        <span class="info">Si no pudieses ejercer tu profesión habitual, percibirías </span>
                        <span class="capital">{{this.numberWithCommas(totalPermanentDisability.social)}} €/mes.</span>
                    </div>
                </div>

                <div class="vx-col input-card" >
                    <md-field>
                        <md-input
                            v-on:keypress="NumbersOnly"
                            name="totalPermanentDisability"
                            style="text-align: center"
                            required
                            v-validate="'required'"
                            val-icon-danger="warning"
                            class="w-full"
                            v-model="totalPermanentDisability.needText"
                            :disabled="totalPermanentDisability.disabled == true"
                            @input="includeCommas(totalPermanentDisability)"
                            @change="checkValues(totalPermanentDisability)"
                        ></md-input>
                        <span class="md-suffix"> €</span>
                    </md-field>
                </div>
            </div>
        </vx-card>
        <vx-card
            v-if="absolutePermanentDisability != null"
            actionable
            :style="{backgroundColor: absolutePermanentDisability.bool ? 'rgba(var(--vs-secundary), 0.18)' : 'none'}"
            class="cover-card"
            >
            <div class="vx-row card-display">
                <div class="vx-col card-description">
                    <div class="title-card">
                        <div class="vx-row">
                            <vs-switch 
                                class="switch-capital mr-4" 
                                v-model="absolutePermanentDisability.bool" 
                                @click="changeSwitchCapital(absolutePermanentDisability)"
                                :disabled="absolutePermanentDisability.disabled == true"
                                ></vs-switch>
                            <span> {{absolutePermanentDisability.name}} y {{greatDisability.name}}</span>
                        </div>
                    </div>

                    <div class="info-card">
                        <span class="info">Si no pudieses trabajar en ningún tipo de actividad, percibirías </span>
                        <span class="capital">{{this.numberWithCommas(absolutePermanentDisability.social)}} €/mes.</span>
                        <span class="info"> Si además, necesitases asistencia de otra persona para los actos más esenciales de la vida, la cantidad sería de </span>
                        <span class="capital">{{this.numberWithCommas(greatDisability.social)}} €/mes</span>

                        <span class="info">. Puede que las cantidades sean insuficientes para tus cuidados, la adaptación de la vivienda u otras necesidades. Indícanos cuánto crees 
                            que necesitarías al mes.</span>
                    </div>
                </div>

                <div class="vx-col input-card" >
                        <md-field>
                            <md-input
                                v-on:keypress="NumbersOnly"
                                name="absolutePermanentDisability"
                                style="text-align: center"
                                required
                                v-validate="'required'"
                                val-icon-danger="warning"
                                class="w-full"
                                v-model="absolutePermanentDisability.needText"
                                :disabled="absolutePermanentDisability.disabled == true"
                                @change="checkValues(absolutePermanentDisability)"
                                @input="includeCommas(absolutePermanentDisability)"
                            ></md-input>
                            <span class="md-suffix"> €</span>
                            </md-field>
                        
                </div>
            </div>
        </vx-card>

        <vx-card
            v-if="widowhood != null"
            actionable
            :style="{backgroundColor: widowhood.bool ? 'rgba(var(--vs-secundary), 0.18)' : 'none'}"
            class="cover-card"
            >
            <div class="vx-row card-display">
                <div class="vx-col card-description">
                    <div class="title-card">
                        <div class="vx-row">
                            <vs-switch class="switch-capital mr-4" v-model="widowhood.bool" @click="changeSwitchCapital(widowhood)"></vs-switch>
                            <span> {{widowhood.name}}</span>
                        </div>
                    </div>

                    <div class="info-card">
                        <span class="info">En caso de fallecimiento la/el vuida/o percibiría </span>
                        <span class="capital">{{this.numberWithCommas(widowhood.social)}} €/mes</span>
                        <span class="info">. Es posible que la cantidad sea insuficiente, salvo que existan ahorros o patrimonio. Si quieres complementar la cantidad, indícanos cuánto al mes.</span>
                    </div>
                </div>

                <div class="vx-col input-card" >
                    <md-field>
                        <md-input
                            v-on:keypress="NumbersOnly"
                            name="widowhood"
                            style="text-align: center"
                            required
                            v-validate="'required'"
                            val-icon-danger="warning"
                            class="w-full"
                            v-model="widowhood.needText"
                            @input="includeCommas(widowhood)"
                            @change="checkValues(widowhood)"
                        ></md-input>
                        <span class="md-suffix"> €</span>
                    </md-field>
                </div>
            </div>
        </vx-card>

        <vx-card
            v-if="orphanhood != null"
            actionable
            :style="{backgroundColor: orphanhood.bool ? 'rgba(var(--vs-secundary), 0.18)' : 'none'}"
            class="cover-card"
            >
            <div class="vx-row card-display">
                <div class="vx-col card-description">
                    <div class="title-card">
                        <div class="vx-row">
                            <vs-switch class="switch-capital mr-4" v-model="orphanhood.bool" @click="changeSwitchCapital(orphanhood)"></vs-switch>
                            <span> {{orphanhood.name}}</span>
                        </div>
                    </div>

                    <div class="info-card">
                        <span class="info">En caso de fallecimiento, los hijos percibirían un total de </span>
                        <span class="capital">{{this.numberWithCommas(orphanhood.social)}} €/mes</span>
                        <span class="info">. Si esa cantidad no cubre su manutención, formación y otros, pon la cantidad que necesitarían mensualmente.
                            </span>
                    </div>
                </div>

                <div class="vx-col input-card" >
                    <md-field>
                        <md-input
                            v-on:keypress="NumbersOnly"
                            name="orphanhood"
                            style="text-align: center"
                            required
                            v-validate="'required'"
                            val-icon-danger="warning"
                            class="w-full"
                            v-model="orphanhood.needText"
                            @input="includeCommas(orphanhood)"
                            @change="checkValues(orphanhood)"
                        ></md-input>
                        <span class="md-suffix"> €</span>
                    </md-field>
                </div>
            </div>
        </vx-card>

        <div class="pt-3">
            <navegation-buttons id="buttons"
                v-bind:code="code"
                v-bind:previus="previus"
                v-bind:next="next"
                @nextStep="goToNextStep()">
            </navegation-buttons>
        </div>

        <!-- <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="¿Hablamos?" :active.sync="callServicePopup">
            <call-service-popup
                v-bind:callServicePopup="callServicePopup"
                v-bind:callServiceType="callServiceType"
                @closeCallServicePopup="closeCallServicePopup"
            >
            </call-service-popup>
        </vs-popup>

        <div  class="box-buttons mt-12">
            <div class="back-button no-fill-button">
                <vs-button
                class="vs-button previous-product"
                @click="goToPreviusStep()"
                >
                Anterior
                </vs-button>
            </div>
            <div class="call-button no-fill-button">
                <vs-button
                    @click="callService()"
                >
                <img src="../../../../assets/images/logo/call-phone-icon.png" width="15px" height="15px"/>
                    Solicitar llamada
                </vs-button>
            </div>

            <div class="next-button no-fill-button">
                <vs-button
                    class="vs-button"
                    @click="goToNextStep()"
                >
                Siguiente</vs-button>
            </div>
        </div> -->

    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import NavegationButtons from '../navegationButtons/NavegationButtons.vue'
import vSelect from 'vue-select'

// import CallServicePopup from '../../../components/eprevision-components/callServicePopup/CallServicePopup.vue';

export default {
  components: { 
      VxCard, 
      NavegationButtons,
    //   CallServicePopup ,
      vSelect},

    name: 'commercial-offer-social-security',
    props: {
        commercialOffer: Object,
        code: String,
        next: String,
        previus: String,
    },
    data() {
        return {
            
            offerCalculatedResponse: null,
            // callServiceType:"helpProcess",
            // callServicePopup: false,
            switchSelectCapital: false,
            switchInitial: false,
            dataStored: null,
            initialData: null,
            clientsNeeds: null,
            socialSecurity: null,
            error_occured: false,
            absolutePermanentDisability: null,
            temporaryDisability: null,
            greatDisability: null,
            totalPermanentDisability: null,
            orphanhood: null,
            widowhood: null,

            contractable: {
                IPA: null,
                IPT: null, 
                IT: null
            },
            
            maximum: 0,
            salaryYear: 0,
            salaryMonth: 0,
            recommendedCapital: 4500,
            showSalaryRadio: null,
            needsCapital: null,
            capitalNeeded: [],
            completeSalarySwitch: 0,

            infoButtons: [],
            needsButtonInfo: {
                name: "needsButtonInfo",
                bool: false,
            },
            partialSalaryInfo: {
                name: "partialSalaryInfo",
                bool: false,
            },
            completeSalaryInfo: {
                name: "completeSalaryInfo",
                bool: false,
            }
        }
    },
    
    created() {

        this.dataStored = JSON.parse(localStorage.getItem(this.code))

        if(this.dataStored.socialSecurity) {
            // Used parse & stringify to avoid mutating the original data (this.dataStored.socialSecurity)
            this.socialSecurity = JSON.parse(JSON.stringify(this.dataStored.socialSecurity))
        }

        if (this.dataStored.initialData) {
            this.initialData = this.dataStored.initialData
        }

        if (this.dataStored.clientsNeeds) {
            this.clientsNeeds = this.dataStored.clientsNeeds
        }

        this.initForm();

    },
    methods: {
        
        initForm() {
            this.calculateSalaryMonth()
            this.checkContractableProducts()
        },

        calculateSalaryMonth() {
            if(this.initialData.socialSecurityInput.specialRegimes){
                this.initialData.socialSecurityInput.specialRegimes.forEach(specialRegime => {
                    this.salaryYear = this.salaryYear + specialRegime.income
                })
            }

            if(this.initialData.socialSecurityInput.generalRegimes){
                this.initialData.socialSecurityInput.generalRegimes.forEach(generalRegime => {
                    this.salaryYear = this.salaryYear + generalRegime.income
                })
            }

            this.salaryMonth = parseInt(this.salaryYear / 12)
            this.maximum = parseInt(1.5 * this.salaryMonth)

            if(this.salaryMonth < this.recommendedCapital) {
                this.showSalaryRadio = false
            } else {
                this.showSalaryRadio = true

            }
        },

        checkContractableProducts(){
            let products = []

            if(this.commercialOffer.accidentProductsId) {
                this.commercialOffer.accidentProductsId.forEach(accidentElement =>{
                    products.push(accidentElement)
                })
            } 
            
            if(this.commercialOffer.iTProductsId) {
                this.commercialOffer.iTProductsId.forEach(ItElement =>{
                    products.push(ItElement)
                })
            } 

            if(this.commercialOffer.lifeProductsId) {
                this.commercialOffer.lifeProductsId.forEach(LifeElement =>{
                    products.push(LifeElement)
                })
            } 

            let data = {
                profession: this.initialData.profession, 
                regime: this.initialData.regime,
                productsId: products
            }

            this.$http.post(process.env.VUE_APP_BROKER_API + '/social-security-covers', data)
            .then((response) => {
                this.contractable.IPT = response.data["IPT"]
                this.contractable.IPA = response.data["IPA"]
                this.contractable.IT = response.data["IT"]


                 this.initializeResultsArray()

                // console.log(this.contractable["IPA"])
            });

        },
        

        initializeResultsArray(){

            if (this.socialSecurity.absolutePermanentDisability) {
                
                this.absolutePermanentDisability = {
                    name: this.socialSecurity.absolutePermanentDisability.name,
                    social: parseInt(this.socialSecurity.absolutePermanentDisability.value),
                    bool: true,
                    need: 0,
                    needText: "",
                    disabled: false,
                }

                if(this.contractable.IPA == false){
                    this.absolutePermanentDisability.bool = false
                    this.absolutePermanentDisability.disabled = true
                    this.absolutePermanentDisability.need = parseInt(this.absolutePermanentDisability.social)
                    this.absolutePermanentDisability.needText = this.numberWithCommas(this.absolutePermanentDisability.social)
                }
                
            }

            if (this.socialSecurity.totalPermanentDisability) {

                this.totalPermanentDisability = {
                    name: this.socialSecurity.totalPermanentDisability.name,
                    social: parseInt(this.socialSecurity.totalPermanentDisability.value),
                    bool: true,
                    need: 0,
                    needText: "",
                    disabled: false,
                }

                if(this.contractable.IPT == false){
                    this.totalPermanentDisability.bool = false
                    this.totalPermanentDisability.disabled = true
                    this.totalPermanentDisability.need = parseInt(this.totalPermanentDisability.social)
                    this.totalPermanentDisability.needText = this.numberWithCommas(this.totalPermanentDisability.social)
                }
                
            }

            if (this.socialSecurity.greatDisability) {

                this.greatDisability = {
                    name: this.socialSecurity.greatDisability.name,
                    social: parseInt(this.socialSecurity.greatDisability.value),
                    bool: true,
                    need: 0,
                    needText: "",
                    disabled: false,
                }
            }

            if (this.socialSecurity.temporaryDisability) {

                this.temporaryDisability = {
                    name: this.socialSecurity.temporaryDisability.name,
                    social: parseInt(this.socialSecurity.temporaryDisability.value),
                    bool: true,
                    need: 0,
                    needText: "",
                    disabled: false,
                }

                if(this.contractable.IT == false){
                    this.temporaryDisability.bool = false
                    this.temporaryDisability.disabled = true
                    this.temporaryDisability.need = parseInt(this.temporaryDisability.social)
                    this.temporaryDisability.needText = this.numberWithCommas(this.temporaryDisability.social)
                }

            }

            if (this.socialSecurity.widowhood) {

                this.widowhood = {
                    name: this.socialSecurity.widowhood.name,
                    social: parseInt(this.socialSecurity.widowhood.value),
                    bool: true,
                    need: 0,
                    needText: "",
                    disabled: false,
                }
            }

            if (this.socialSecurity.orphanhood) {

                this.orphanhood = {
                    name: this.socialSecurity.orphanhood.name,
                    social: parseInt(this.socialSecurity.orphanhood.value),
                    bool: true,
                    need: 0,
                    needText: "",
                    disabled: false,
                }

            }

            if (this.clientsNeeds == null) {
                this.calculateCapitalsNeeded()
            } else {
                this.completeSalarySwitch = this.clientsNeeds.completeSalarySwitch
                this.restoreCapitalsNeeded()
            }
        },

        calculateCapitalsNeeded(){
        // Recommendation (this.recommendedCapital) if onlyAQuantity of salary is selected: 4500 when salary is higher than this number.
        // Antonio fixed this value, as he thinks it is enough in each of the covers (orphanhood & widowhood split the 4500 by 48% and 52%)
        // "Statistacaly this should be enough in each case"

            if(this.completeSalarySwitch == 1){
                this.setCapitalNeed(this.salaryMonth)
            } else {
                if(this.salaryMonth < this.recommendedCapital) {
                    this.setCapitalNeed(this.salaryMonth)
                } else {
                    this.setRecommendedCapital(this.recommendedCapital)
                }
            }
        },

        setCapitalNeed(capital){

            if(this.absolutePermanentDisability != null && this.absolutePermanentDisability.bool == true) {
                this.absolutePermanentDisability.need = capital
                this.absolutePermanentDisability.needText = this.numberWithCommas(capital)
            }
            if(this.totalPermanentDisability != null && this.totalPermanentDisability.bool == true) {
                this.totalPermanentDisability.need = capital
                this.totalPermanentDisability.needText = this.numberWithCommas(capital)
            }
            // if(this.greatDisability != null && this.greatDisability.bool == true) {
            //     this.greatDisability.need = capital
            //     this.greatDisability.needText = this.numberWithCommas(capital)
            // }
            if(this.temporaryDisability != null && this.temporaryDisability.bool == true) {
                this.temporaryDisability.need = capital
                this.temporaryDisability.needText = this.numberWithCommas(capital)
            }
            if(this.widowhood != null && this.widowhood.bool == true) {
                let widowhoodValue = parseInt(capital * 0.52)
                
                this.widowhood.need = widowhoodValue
                this.widowhood.needText = this.numberWithCommas(widowhoodValue)
            }
            if(this.orphanhood != null && this.orphanhood.bool == true) {
                let orphanValue = parseInt(capital * 0.48)

                this.orphanhood.need = orphanValue
                this.orphanhood.needText = this.numberWithCommas(orphanValue)
            }
        },

        setRecommendedCapital(capital){

            if(this.absolutePermanentDisability != null && this.absolutePermanentDisability.bool == true) {
                let absoluteValue = capital + 1000
                this.absolutePermanentDisability.need = absoluteValue 
                this.absolutePermanentDisability.needText = this.numberWithCommas(absoluteValue)
            }

            if(this.totalPermanentDisability != null && this.totalPermanentDisability.bool == true) {
                this.totalPermanentDisability.need = capital
                this.totalPermanentDisability.needText = this.numberWithCommas(capital)
            }

            // if(this.greatDisability != null && this.greatDisability.bool == true) {
            //     this.greatDisability.need = capital
            //     this.greatDisability.needText = this.numberWithCommas(capital)
            // }
            
            if(this.temporaryDisability != null && this.temporaryDisability.bool == true) {
                if(this.salaryMonth > 6000) {
                    let temporaryValue = 6000
                    this.temporaryDisability.need = temporaryValue
                    this.temporaryDisability.needText = this.numberWithCommas(temporaryValue)
                } else {
                    let temporaryValue = this.salaryMonth
                    this.temporaryDisability.need = temporaryValue
                    this.temporaryDisability.needText = this.numberWithCommas(temporaryValue)
                }
            }

            if(this.widowhood != null && this.widowhood.bool == true) {
                let widowhoodValue = parseInt(capital * 0.52)
                this.widowhood.need = widowhoodValue
                this.widowhood.needText = this.numberWithCommas(widowhoodValue)
            }

            if(this.orphanhood != null && this.orphanhood.bool == true) {
                let orphanValue = parseInt(capital * 0.48)
                this.orphanhood.need = orphanValue
                this.orphanhood.needText = this.numberWithCommas(orphanValue)
            }
        },

        restoreCapitalsNeeded(){
        // If there is a value saved -> load this value
        // If that category did not have a value asigned -> show it as deactivated and need is set to 0 (social value)

            if(this.absolutePermanentDisability != null) {
                if(this.clientsNeeds.clientsCapitals.filter(a => a.name == this.absolutePermanentDisability.name)[0]) {
                    let absoluteData = this.clientsNeeds.clientsCapitals.filter(a => a.name == this.absolutePermanentDisability.name)[0]
    
                    this.absolutePermanentDisability.need = absoluteData.need
                    this.absolutePermanentDisability.needText = absoluteData.needText
                    this.absolutePermanentDisability.bool = absoluteData.bool
                } else {
                    let absoluteData = parseInt(this.socialSecurity.absolutePermanentDisability.value)

                    this.absolutePermanentDisability.need =  absoluteData
                    this.absolutePermanentDisability.needText = this.numberWithCommas(absoluteData)
                    this.absolutePermanentDisability.bool = false
                }
            }

            if(this.totalPermanentDisability != null) {
                if(this.clientsNeeds.clientsCapitals.filter(b => b.name == this.totalPermanentDisability.name)[0]) {
                    let totalData = this.clientsNeeds.clientsCapitals.filter(b => b.name == this.totalPermanentDisability.name)[0]

                    this.totalPermanentDisability.need = totalData.need
                    this.totalPermanentDisability.needText = totalData.needText
                    this.totalPermanentDisability.bool = totalData.bool
                } else {
                    let totalData = parseInt(this.socialSecurity.totalPermanentDisability.value)

                    this.totalPermanentDisability.need =  totalData
                    this.totalPermanentDisability.needText = this.numberWithCommas(totalData)
                    this.totalPermanentDisability.bool = false
                }
            }

            if(this.greatDisability != null) {
                if(this.clientsNeeds.clientsCapitals.filter(c => c.name == this.greatDisability.name)[0]) {
                    let greatData = this.clientsNeeds.clientsCapitals.filter(c => c.name == this.greatDisability.name)[0]

                    this.greatDisability.need = greatData.need
                    this.greatDisability.needText = greatData.needText
                    this.greatDisability.bool = greatData.bool
                } else {
                    let greatData = parseInt(this.socialSecurity.greatDisability.value)

                    this.greatDisability.need =  greatData
                    this.greatDisability.needText = this.numberWithCommas(greatData)
                    this.greatDisability.bool = false
                }
            }

            if(this.temporaryDisability != null) {
                if(this.clientsNeeds.clientsCapitals.filter(d => d.name == this.temporaryDisability.name)[0]) {
                    let temporaryData = this.clientsNeeds.clientsCapitals.filter(d => d.name == this.temporaryDisability.name)[0]
    
                    this.temporaryDisability.need = temporaryData.need
                    this.temporaryDisability.needText = temporaryData.needText
                    this.temporaryDisability.bool = temporaryData.bool
                } else {
                    let temporaryData = parseInt(this.socialSecurity.temporaryDisability.value)

                    this.temporaryDisability.need =  temporaryData
                    this.temporaryDisability.needText = this.numberWithCommas(temporaryData)
                    this.temporaryDisability.bool = false
                }
            }

            if(this.widowhood != null) {
                if(this.clientsNeeds.clientsCapitals.filter(e => e.name == this.widowhood.name)[0]) {
                    let widowhoodData = this.clientsNeeds.clientsCapitals.filter(e => e.name == this.widowhood.name)[0]

                    this.widowhood.need = widowhoodData.need
                    this.widowhood.needText = widowhoodData.needText
                    this.widowhood.bool = widowhoodData.bool

                } else {
                    let widowhoodData = parseInt(this.socialSecurity.widowhood.value)

                    this.widowhood.need =  widowhoodData
                    this.widowhood.needText = this.numberWithCommas(widowhoodData)
                    this.widowhood.bool = false
                }
            }

            if(this.orphanhood != null) {
                if(this.clientsNeeds.clientsCapitals.filter(f => f.name == this.orphanhood.name)[0]) {
                    let orphanhoodData = this.clientsNeeds.clientsCapitals.filter(f => f.name == this.orphanhood.name)[0]
    
                    this.orphanhood.need = orphanhoodData.need
                    this.orphanhood.needText = orphanhoodData.needText
                    this.orphanhood.bool = orphanhoodData.bool

                } else {
                    let orphanhoodData = parseInt(this.socialSecurity.orphanhood.value)

                    this.orphanhood.need =  orphanhoodData
                    this.orphanhood.needText = this.numberWithCommas(orphanhoodData)
                    this.orphanhood.bool = false
                }
            }
        },

        // cardSwitch(switchChanged){

        //     if(switchChanged.bool == false){
        //         switchChanged.bool = true

        //         if(this.completeSalarySwitch == 0) {
        //             if(switchChanged.name == "Viudedad"){
                        
        //                 switchChanged.need = parseInt(this.recommendedCapital * 0.52)
        //             } else if(switchChanged.name == "Orfandad"){
        //                 switchChanged.need = parseInt(this.recommendedCapital * 0.48)
        //             } else {
        //                 switchChanged.need = this.recommendedCapital
        //             }
        //         } else {
        //             if(switchChanged.name == "Viudedad"){
        //                 switchChanged.need = parseInt(this.salaryMonth * 0.52)
        //             } else if(switchChanged.name == "Orfandad"){
        //                 switchChanged.need = parseInt(this.salaryMonth * 0.48)
        //             } else {
        //                 switchChanged.need = this.salaryMonth
        //             }
        //         }

        //         return switchChanged

        //     } else {

        //         switchChanged.bool = false
        //         switchChanged.need = 0

        //         return switchChanged
        //     }
        // },

        changeSwitchCapital(switchChanged){
            // absolutePermanentDisability
            if(switchChanged.bool == true) {
                switchChanged.need = switchChanged.social
                switchChanged.needText = this.numberWithCommas(switchChanged.social)
                
            } else {
                let value = 0

                if(this.completeSalarySwitch == 0 && this.salaryMonth > this.recommendedCapital) {
                    if(switchChanged.name == "Viudedad"){
                        value = parseInt(this.recommendedCapital * 0.52)

                    } else if(switchChanged.name == "Orfandad"){
                        value = parseInt(this.recommendedCapital * 0.48)

                    } else {
                        value = this.recommendedCapital
                    }
                } else {
                    if(switchChanged.name == "Viudedad"){
                        value = parseInt(this.salaryMonth * 0.52)

                    } else if(switchChanged.name == "Orfandad"){
                        value = parseInt(this.salaryMonth * 0.48)

                    } else {
                        value = this.salaryMonth

                    }
                }

                switchChanged.need = value
                switchChanged.needText = this.numberWithCommas(value)
            }
        },

        // INICIAL -> antes de cards
        // changeSwitchCapital(switchChanged){

        //     if(switchChanged.bool == false) {
        //         console.log("aqui")
        //         switchChanged.need = 0
        //     } else {
        //         console.log("aqui2")

        //         if(this.completeSalarySwitch == 0) {
        //             if(switchChanged.name == "Viudedad"){
        //                 switchChanged.need = this.recommendedCapital * 0.52
        //             } else if(switchChanged.name == "Orfandad"){
        //                 switchChanged.need = this.recommendedCapital * 0.48
        //             } else {
        //                 switchChanged.need = this.recommendedCapital
        //             }
        //         } else {
        //             if(switchChanged.name == "Viudedad"){
        //                 switchChanged.need = this.salaryMonth * 0.52
        //             } else if(switchChanged.name == "Orfandad"){
        //                 switchChanged.need = this.salaryMonth * 0.48
        //             } else {
        //                 switchChanged.need = this.salaryMonth
        //             }
        //         }
        //     }
        // },

        checkValues(product){

            if(product.need > this.maximum) {
                let value = 0
                if(product.name == "Viudedad"){
                    value = parseInt(this.maximum * 0.52)
                    
                } else if(product.name == "Orfandad"){
                    value = parseInt(this.maximum * 0.48)
    
                } else {
                    value = this.maximum
                }

                product.need = value
                product.needText = this.numberWithCommas(value)
                product.bool = true


                // maximum for each product is calculated and assigned to product.need -> depends on % of coverages
                this.$vs.notify({
                    title: 'Capital máximo superado',
                    text: 'La necesidad máxima al mes que puedes solicitar por cada producto es de ' + product.needText + ' €',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })

            } else if(product.need <= product.social || product.need == "") {
                let value = product.social

                product.bool = false
                product.need = value
                product.needText = this.numberWithCommas(value)

                this.$vs.notify({
                    title: 'Mínimo de necesidad',
                    text: 'La necesidad deber ser como mínimo el importe de la prestación',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            } else {
                product.bool = true
            }

            return product

        },

        // callService() {
        //     this.callServicePopup = true;
        // },

        // closeCallServicePopup(value){
        //     this.callServicePopup = value;
        // },

        // goToPreviusStep() {
        //     this.$router
        //     .push("/"+ this.previus + "-step/" + this.code)
        //     .catch(() => {});
        // },

        errorCapitalsIncluded() {
            let productsIncluded = 0
            
            if (this.socialSecurity.absolutePermanentDisability) {
                if(this.absolutePermanentDisability.bool == true) {
                    productsIncluded = productsIncluded + 1
                }
            }

            if (this.socialSecurity.totalPermanentDisability) {
                if(this.totalPermanentDisability.bool == true) {
                    productsIncluded = productsIncluded + 1
                }
            }

            if (this.socialSecurity.greatDisability) {
                if(this.greatDisability.bool == true) {
                    productsIncluded = productsIncluded + 1
                }
            }

            if (this.socialSecurity.temporaryDisability) {
                if(this.temporaryDisability.bool == true) {
                    productsIncluded = productsIncluded + 1
                }
            }

            if (this.socialSecurity.widowhood) {
                if(this.widowhood.bool == true) {
                    productsIncluded = productsIncluded + 1
                }
            }

            if (this.socialSecurity.orphanhood) {
                if(this.orphanhood.bool == true) {
                    productsIncluded = productsIncluded + 1
                }
            }

            if (productsIncluded > 0) {
                this.error_occured = false
                return this.error_occured

            } else {
                this.error_occured = true
                return this.error_occured

            }
        },

        goToNextStep() {
            // Check if there is atleast 1 active
            if (this.errorCapitalsIncluded() == false) {
                                
                this.$vs.loading({ type: "sound" });
                
                this.error_occured = false

                this.needsCapital = {
                    absolutPermanentDisabilityCapital: 0,
                    needsAbsolutPermanentDisabilityCapital: 0,
                    totalPermanentDisabilityCapital: 0,
                    needsTotalPermanentDisabilityCapital: 0,
                    greatDisabilityCapital: 0,
                    needsGreatDisabilityCapital: 0,
                    temporaryDisabilityCapital: 0,
                    needsTemporaryDisabilityCapital: 0,
                    orphanhoodCapital: 0,
                    needsOrphanhoodCapital: 0,
                    widowhoodCapital:0,
                    needsWidowhoodCapital: 0,
                    age: this.initialData.age,
                    childrenAges: this.initialData.socialSecurityInput.childrenAges,
                    ageSpouse: this.initialData.socialSecurityInput.ageSpouse,
                    income: this.salaryYear
                    
                }

                if(this.absolutePermanentDisability != null) {

                    if(this.absolutePermanentDisability.bool == true) {
                        this.needsCapital.absolutPermanentDisabilityCapital = this.absolutePermanentDisability.social
                        this.needsCapital.needsAbsolutPermanentDisabilityCapital = this.absolutePermanentDisability.need
                    }
                    
                    this.greatDisability.bool = this.absolutePermanentDisability.bool
                    this.greatDisability.need = this.absolutePermanentDisability.need
                    this.greatDisability.needText = this.absolutePermanentDisability.needText

                    this.needsCapital.greatDisabilityCapital = this.greatDisability.social
                    this.needsCapital.needsGreatDisabilityCapital = this.greatDisability.need

                    this.capitalNeeded.push(this.absolutePermanentDisability)
                    this.capitalNeeded.push(this.greatDisability)

                }

                if(this.totalPermanentDisability != null) {
                    if(this.totalPermanentDisability.bool == true) {
                        this.needsCapital.totalPermanentDisabilityCapital = this.totalPermanentDisability.social
                        this.needsCapital.needsTotalPermanentDisabilityCapital = this.totalPermanentDisability.need
                    }

                    this.capitalNeeded.push(this.totalPermanentDisability)
                }

                // if(this.greatDisability != null) {
                //     if(this.greatDisability.bool == true) {
                //         this.needsCapital.greatDisabilityCapital = this.greatDisability.social
                //         this.needsCapital.needsGreatDisabilityCapital = this.greatDisability.need
                //     }

                //     this.capitalNeeded.push(this.greatDisability)
                // }

                if(this.temporaryDisability != null) {
                    if(this.temporaryDisability.bool == true) {
                        this.needsCapital.temporaryDisabilityCapital = this.temporaryDisability.social
                        this.needsCapital.needsTemporaryDisabilityCapital = this.temporaryDisability.need
                    }

                    this.capitalNeeded.push(this.temporaryDisability)
                }

                if(this.widowhood != null) {
                    if(this.widowhood.bool == true) {
                        this.needsCapital.widowhoodCapital = this.widowhood.social
                        this.needsCapital.needsWidowhoodCapital = this.widowhood.need
                        // this.needsCapital.needsWidowhoodCapital = this.widowhood.need / 0.52

                    }

                    this.capitalNeeded.push(this.widowhood)
                }

                if(this.orphanhood != null) {
                    if(this.orphanhood.bool == true) {
                        this.needsCapital.orphanhoodCapital = this.orphanhood.social
                        this.needsCapital.needsOrphanhoodCapital = this.orphanhood.need
                        // this.needsCapital.needsOrphanhoodCapital = this.orphanhood.need / 0.48

                    }

                    this.capitalNeeded.push(this.orphanhood)
                }

                this.dataStored.clientsNeeds = {
                    salaryMonth: this.salaryMonth,
                    clientsCapitals: this.capitalNeeded,
                    completeSalarySwitch: this.completeSalarySwitch
                    // initialCoverageChart: null,
                }

                this.$http.post(process.env.VUE_APP_BROKER_API + '/needs-capital', this.needsCapital)
                .then((response) => {

                    let needsCapitalData = {
                        commercialOfferCode: this.code,
                        profession:this.dataStored.initialData.profession,
                        regime: this.getRegime(),
                        needsCapitals: {
                            temporaryDisability: response.data.temporaryDisability,
                            totalPermanentDisability: response.data.totalPermanentDisability,
                            greatDisability: response.data.greatDisability,
                            absolutPermanentDisability: response.data.absolutPermanentDisability,
                            fall: response.data.fall,
                            orphanhood: response.data.orphanhood,
                            widowhood: response.data.widowhood,
                        }
                    }

                    this.dataStored.needsCapitals = needsCapitalData.needsCapitals


                    this.$http.post(process.env.VUE_APP_BROKER_API + '/capital-distribution', needsCapitalData)
                    .then((responseDistribution) => {

                        let covers = responseDistribution.data

                        covers.coverages.forEach(cover => {
                            cover.productId = cover.product
                        })

                        this.dataStored.initialOffer = {
                            initialCoverageChart: covers
                        }
                        this.dataStored.negotationData = null

                        // this.dataStored.initialCoverageChart = covers
                        localStorage.setItem(this.code, JSON.stringify(this.dataStored))

                        this.$router
                        .push("/" + this.next + "-step/" + this.code)
                        .catch(() => {});
                    })

                });
            } else {

                 this.$vs.notify({
                    title: 'Selecciona prestaciones',
                    text: 'Marca las prestaciones a complementar para poder hacer los cálculos',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
        },

        getRegime() {
            let regime = ""

            if(this.dataStored.initialData.regimes.length == 1){
                regime = this.dataStored.initialData.regimes[0]
                return regime
            } else {
                let numAjena = 0
                let numPropia = 0
                this.dataStored.initialData.regimes.forEach(regime => {
                    if (regime == "ajena") {
                        numAjena += 1
                    } else {
                        numPropia += 1
                    }
                })

                if(numAjena == numPropia || numAjena > numPropia) {
                    regime = "ajena"
                } else {
                    regime = "propia"
                }

                return regime
            }
        },


        checkInfo(buttonPressed){
            if (buttonPressed.bool == true) {
                buttonPressed.bool = false
            } else {
                buttonPressed.bool = true
            }
        },

        numberWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },

        includeCommas(number) {
            if(number.needText.includes(".")){

                let numbersSplit = number.needText.split(".")
                let numbersJoined = ""
                numbersSplit.forEach(element => {
                    numbersJoined = numbersJoined + element
                })

                number.need = parseInt(numbersJoined)
                number.needText = numbersJoined.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            } else {
                number.need = parseInt(number.needText)
                number.needText =  number.needText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
            return number
        },

        formatImporte(importe){
        if(!isNaN(importe)){
            return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(importe.toFixed(2));
            }
        return importe;
        },


        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) ) {
                // Quitado el punto: && charCode !== 46
                evt.preventDefault();;
            } else {
                return true;
            }
        },

    },
    // computed: {
    //     checkValue() {

    //         if (this.absolutePermanentDisability) {
    //             this.greatDisability.bool = this.absolutePermanentDisability.bool
    //             if(this.greatDisability.bool == true) {
    //                 this.greatDisability.need = this.absolutePermanentDisability.need
    //                 this.greatDisability.needText = this.numberWithCommas(this.absolutePermanentDisability.need)
    //             } else {
    //                 this.greatDisability.need = this.greatDisability.social
    //                 this.greatDisability.needText = this.numberWithCommas(this.greatDisability.social)
    //             }
    //         }
    //     }
    // }

}

</script>
<style lang="scss">

#input-form-social-security {


    .cover-card{
        width:100%;
        text-align:center;
        margin:auto;
        margin-top: 5px;
        border-radius: .5rem;
        box-shadow: 0px 0px 1px 1px rgba(.1, .1, .1, .1) !important;
        
        
        }

    .card-description{
        width: 80%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-content: stretch;
        align-items: flex-start;
        justify-content: space-around;

        padding-bottom: 15px;

        .title-card{
            font-weight: 600;
            text-align: start;
            padding-left: 10px;
            padding-top: 10px;
            margin-bottom: 4px;
            .vx-row{
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: nowrap;
            justify-content: space-around;
            }    
        }

        .info-card{
            text-align: justify;
            margin-left: 10px !important;

            .capital{
                color: rgba(var(--vs-danger), 1);
                font-weight: 600;
            }
        }

    }
    
    .input-card{
        width: 18%;
        text-align: end;
        font-weight: 600;

        .md-field {
            min-width: 70px;
        }
        .md-input{
        font-weight: 500;
        
        }
    }

    .tableTitles{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        align-content: center;
        align-items: center;

    }

    .title{
        font-weight: 600
    }

    // .radio-salary{
    //     width: 50%
    // }

    // .infoTitle{
    //     display: flex;
    //     flex-direction: row;
    //     flex-wrap: nowrap;
    //     justify-content: space-around;
    //     align-items:center;
    // }

    .coverSwitch-title{
        width: 10%;
    }

    .coverInput-title{
        width: 18%;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    // .tooltip .tooltiptext {
    // // Bubble with text in info buttons
    // // To avoid it from hidding when mouse moves away - it is activated/deactivated by button
    // // not by mouse going over
    // visibility: visible;
    // }

    // .tooltip-need { 
        //  span#need-tooltip .tooltip-text  {
        //         margin-left: -200px;
        //         display: flow-root
        //         }
    // } 

    .clickable-icon {
        color: rgba(var(--vs-secundary), 1) !important;
    }

    .coverInfo{
        text-align: justify;
        margin-left: 10px !important;

        .capital{
            color: rgba(var(--vs-danger), 1);
            font-weight: 600;
        }
    }

    .coverSwitch{
        width: 5%;
    }

    .coverInput{
        width: 18%;
        margin-right: 10px;
        margin-bottom: 10px;
    }



    .radioButtons {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        align-items: center;
        align-content: space-between;
    }

    .image {
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
    }



    @media screen and (max-width: 450px) {

        .radioButtons {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            justify-content: space-evenly;
            align-items: flex-start;
            align-content: space-between;
            margin-left: 10%

        }
        #partialSalary{
            margin-top: 10px;
        }

        .salary-tooltip{
  
            position: absolute;
            
            z-index: 1;
            bottom: 130%;
            left: 0%;
            margin-left: -160px !important;
        }

    }


    @media screen and (max-width: 599px) {
        .tableTitles{
            display: none;
        }

        .cover-row{
            margin-top: 20px;
            display: flex;
            flex-direction: column !important;
            flex-wrap: wrap;
            align-content: center;
            justify-content: space-between;
            align-items: center;
        }
        .coverInfo{
            width: 100% !important;
            margin: 0;
        }

        .coverSwitch{
            width: 50%;
            text-align: -webkit-center;
            margin-top: 10px;
        }

        .coverInput{
            width: 30% !important;
            margin-right: 10px;
            margin-bottom: 10px;
        }

        .card-display{
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: space-around;
            justify-content: space-around;
            align-items: center;
        }

        .card-description{
            width: 100%;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-content: stretch;
            align-items: flex-start;
            justify-content: space-around;
            padding-bottom: 0px;
    
            .title-card{
                display: flex;
                flex-wrap: nowrap;
                flex-direction: row;
                align-content: space-around;
                justify-content: space-around;
                align-items: center;
                font-weight: 600;
                text-align: start;
                padding-left: 0px;
                padding-top: 10px;
                margin-bottom: 4px;
            }
    
            .info-card{
                text-align: justify;
                margin-left: 0px !important;
                margin-top: 5px;
    
                .capital{
                    color: rgba(var(--vs-danger), 1);
                    font-weight: 600;
                }
            }
    
        }

        .input-card{
                width: 35%;
                min-width:40px;
                text-align: end;
                font-weight: 600;
                padding-bottom: 10px;

                .md-input{
                font-weight: 500;
                }

        }

        .recommended-tooltip {
  
            position: absolute;
            
            z-index: 1;
            bottom: 150%;
            left: 0%;
            margin-left: -200px !important;
        }

        .salary-tooltip{
  
            position: absolute;
            
            z-index: 1;
            bottom: 130%;
            left: 0%;
            margin-left: -160px !important;
        }

    }

    @media only screen and (min-width : 600px)
  and (max-width : 799px) {
        .cover-row{
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-between;
            align-items: center;
        }

        .coverInfo{
            width: 65% !important;
            margin: 0;
        }

        .coverSwitch{
            width: 10%;
        }

        .tooltip-need {
            width: 20%;
            position: relative;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-end;
            align-items: center;
            align-content: center;

            // flex-direction: column;
            // flex-wrap: nowrap;
            // justify-content: flex-end;
            // align-items: center;
        }

        .coverInput-title{
            width: 60%;
        }

        .card-display{
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-start;
            align-items: stretch;

        }

        .salary-tooltip{
  
            position: absolute;
            
            z-index: 1;
            bottom: 130%;
            left: 0%;
            margin-left: -160px !important;
        }

        .need-tooltip {
  
            position: absolute;
            width: 180px;
            
            z-index: 1;
            bottom: 200%;
            left: 0%;
            margin-left: -120px !important;
        }
        

    }

    @media only screen and (min-width : 800px)
  and (max-width : 1000px) {
        .cover-row{
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-between;
            align-items: center;
        }

        .coverInfo{
            width: 65% !important;
            margin: 0;
        }

        .coverSwitch{
            width: 10%;
        }

        .card-display{
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-start;
            align-items: stretch;

        }

        .need-tooltip {
  
            position: absolute;
            
            z-index: 1;
            bottom: 150%;
            left: 0%;
            margin-left: -200px !important;
        }

    }

    // @media screen and (min-width: 851px) {
    @media screen and (min-width: 1001px) {
        .cover-row{
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-between;
            align-items: center;
        }

        .coverInfo{
            width: 70% !important;
            margin: 0;
        }

        .coverSwitch{
            width: 5%;
        }

        .card-display{
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-start;
            align-items: stretch;

        }

        .need-tooltip {
  
            position: absolute;
            
            z-index: 1;
            bottom: 150%;
            left: 0%;
            margin-left: -200px !important;
        }

    }
}
</style>